<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form   label-position="raght" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      
      <el-form-item label-width="100px" label="渠道名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="渠道名称" ></el-input>
      </el-form-item>
      
      
      <el-form-item label-width="100px" label="回传URL" prop="url">
          <el-input v-model="dataForm.url" placeholder="回传URL"></el-input>
      </el-form-item>
          <el-form-item label-width="100px" label="回传token" prop="token">
          <el-input v-model="dataForm.token" placeholder="回传token"></el-input>
      </el-form-item>
      <el-form-item  label-width="100px" label="代运营机构" prop="operationIdList">
	      <el-select  class="hundred"  v-model="dataForm.operationIdList" filterable multiple placeholder="请选择">
	          <el-option
	                  v-for="item in operationList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      <div style="display:flex">
      <el-form-item label-width="100px" label="状态" prop="status">
          <el-select v-model="dataForm.status" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in statusList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
          </el-select>
      </el-form-item>

      
      <el-form-item label-width="100px" label="去重" prop="operationIdList">
	      <el-select  v-model="dataForm.repeatFlag" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in repeatFlagList"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
    </div>
      <el-form-item label-width="100px" label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="备注"
            v-model="dataForm.remark">
          </el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      operationList:[],
      statusList:[
        {
            'label':'停用',
            'value':0,
        },
        {
            'label':'正常',
            'value':1,
        }
      ],
      repeatFlagList:[
      {
            'label':'不去重',
            'value':0,
        },
        {
            'label':'去重',
            'value':1,
        }
      ],
      dataForm: {
        id: '',
        name: '',
        remark: '',
        operationIdList: '',
        url: '',
        token: '',
        status: '',
        createBy: '',
        createTime: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        repeatFlag:''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        operationIdList: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        token: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.getOperatorsOptions();
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/channels/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data,
          // repeatFlag: res.data.repeatFlag == '1' ? '去重' : '不去重' 
        }
        console.log(res.data.repeatFlag)
        console.log(this.dataForm)
      }).catch(() => {})
    },
    //初始化运营机构下拉框的选项
    async getOperatorsOptions() {
        this.$http.get(`/sys/operations/listAll`).then(({data: res}) => {
          console.log(res)
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.operationList = [];
            if (res.data != null) {
                res.data.forEach(element => {
                    this.operationList.push({label: element.name, value: element.id})
                })
            }
        }).catch(() => {
        })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
      
        for (const key in this.dataForm) {
          if (Object.hasOwnProperty.call(this.dataForm, key) && typeof this.dataForm[key] == 'string') {
              this.dataForm[key] = this.dataForm[key].replace(/^\s*|\s*$/g,"");
          }
        }
        console.log(this.dataForm)
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/channels/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
